import React from 'react';
import {Icon} from '../../../../library/decor/SarasIcons'
// import SarasDnDCard from '../../../../library/hooks/bdnd/SarasDnDCard';
import SarasDnDCard from '../../../../library/hooks/dndkit/SarasDnDCard';
import SarasTooltip from '../../../../library/notifications/SarasTooltip';

const ColumnSelectorCol = (props) => {
    const {viewData, index, rowKey, onToggleVisibility, isHidden} = props;

    //hidden list will have action to make the column visible and vice versa
    let ActionIcon = Icon[ isHidden ? "confirm" : "clear"];
    // console.log("column selector", viewData);

    const onAction = () => {
        onToggleVisibility(rowKey, isHidden);
    }

    return (
        <SarasDnDCard rowKey={rowKey} index={index}>
            <li className="uiShrinkInSort uiSpacerL5" style={{listStyle: 'none'}}>
                <div className="uiColumnSelectorCol uiFlexDistributed">
                    <span>{viewData.valF}</span>
                    <SarasTooltip title={isHidden ? "Show Column" : "Hide Column"}>
                        <ActionIcon 
                            className={`${isHidden ? "uiColorNeutralAction" : "uiColorNegativeAction"}`} 
                            onClick={onAction}/>
                    </SarasTooltip>
                </div>
            </li>
        </SarasDnDCard>
    )
}

export default ColumnSelectorCol
